<template>
  <div id="aboutmenu" class="wrap-1500">
    <div class="nav">
        <!-- <router-link to="/">Home</router-link> -->
        <router-link to="/about" >
          <Navlink :text="$t('about.menu.about')"
            :menu="true"
            :dark="false"
            :border="false" />
        </router-link>
        <router-link to="/story" >
          <Navlink :text="$t('about.menu.story')"
            :menu="true"
            :dark="false"
            :border="false" />
        </router-link>
        <router-link to="/movie" >
          <Navlink :text="$t('about.menu.movie')"
            :menu="true"
            :dark="false"
            :border="false" />
        </router-link>
        <router-link to="/honor" >
          <Navlink :text="$t('about.menu.honor')"
            :menu="true"
            :dark="false"
            :border="false" />
        </router-link>
        <router-link to="/history" >
          <Navlink :text="$t('about.menu.history')"
            :menu="true"
            :dark="false"
            :border="false" />
        </router-link>
      </div>
  </div>
</template>

<script>
import Navlink from '@/components/Navlink.vue'

export default {
  components: {
    Navlink
  }
}
</script>

<style lang="scss" scoped>
.wrap-1500 {
  padding: 8px 30px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: flex-end;
  max-width: 1500px;
}

.nav {
  display: flex;
}
@media(max-width: 1366px){
  #aboutmenu{
    padding-left: 20px;
    padding-right: 20px;
    .nav{
      width:80%;
      justify-content: space-between;
      .navlink{
        font-size: 14px;
        width: auto;
      }
    }
  }
}
@media(max-width: 768px){
  #aboutmenu{
    .nav{
      width:100%;
    }
  }
}
</style>

<style lang="scss">
.router-link-exact-active .navlink.menu {
  color: #5998c4;
  // font-weight: 800;
}
</style>
